import dayjs from "dayjs";

const LOCAL_DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const DATE_PICKER_FORMATS_BY_LANGUAGE: Record<string, string> = {
    de: "DD.MM.YYYY",
    en: "MM/DD/YYYY",
    hr: "DD.MM.YYYY",
    it: "DD/MM/YYYY"
};

const parseLocalDate = (value: string) => {
    const dateOnlyMatch = value.match(LOCAL_DATE_ONLY_PATTERN);
    if (dateOnlyMatch) {
        const year = Number(dateOnlyMatch[1]);
        const month = Number(dateOnlyMatch[2]) - 1;
        const day = Number(dateOnlyMatch[3]);
        return dayjs(new Date(year, month, day));
    }

    return dayjs(value);
};

export const formatLocalDate = (value?: string | null, fallback = "-") => {
    if (!value) {
        return fallback;
    }

    const parsed = parseLocalDate(value);
    return parsed.isValid() ? parsed.format("DD.MM.YYYY") : fallback;
};

export const formatLocalDateTime = (value?: string | null, fallback = "-") => {
    if (!value) {
        return fallback;
    }

    const parsed = parseLocalDate(value);
    return parsed.isValid() ? parsed.format("DD.MM.YYYY HH:mm") : fallback;
};

export const resolveLocalizedDatePickerFormat = (language?: string | null) => {
    const languageCode = language?.split("-")[0]?.toLowerCase() ?? "hr";
    return DATE_PICKER_FORMATS_BY_LANGUAGE[languageCode] ?? DATE_PICKER_FORMATS_BY_LANGUAGE.hr;
};
